<template>
  <div class="container-fluid">
    <div class="loading" v-if="isBusy">Loading&#8230;</div>

    <div class="view-header my-4">
      <div class="view-header__main">
        <div class="view-header__info">
          <h1 class="view-header__title">Puntos de venta</h1>
          <p class="view-header__subtitle">Gestioná los puntos de venta y la facturación electrónica.</p>
        </div>
        <div class="view-header__actions">
          <button type="button" class="btn view-header__btn view-header__btn--primary" @click="afipUpdate()">
            <i class="bi bi-arrow-repeat"></i>
            Actualizar datos AFIP
          </button>
        </div>
      </div>
    </div>

    <div class="row">
      <!-- TABLA -->
      <div class="col-md-8">
        <div class="data-table">
          <div class="table-responsive">
            <table class="table mb-0">
              <thead>
                <tr>
                  <th>Número</th>
                  <th>Sucursal</th>
                  <th>Tipo</th>
                  <th>Tipo de numeración</th>
                  <th>Estado</th>
                  <th class="text-right">Acciones</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="sp in salePoints" :key="sp.id">
                  <td><span class="data-table__primary">{{ sp.number }}</span></td>
                  <td>{{ sp.branchoffice && sp.branchoffice.name }}</td>
                  <td>{{ sp.type }}</td>
                  <td>{{ sp.editable == 1 ? 'Editable' : 'Automática' }}</td>
                  <td>
                    <span
                      class="status-badge"
                      :class="sp.actived == 1 ? 'status-badge--success' : 'status-badge--danger'"
                    >
                      {{ sp.actived == 1 ? 'Habilitado' : 'Deshabilitado' }}
                    </span>
                  </td>
                  <td class="text-right">
                    <div v-if="canEdit(sp.id)" class="table-action-group">
                      <button class="table-action-btn" type="button" title="Editar" @click="edit(sp.id)">
                        <i class="bi bi-pencil"></i>
                      </button>
                      <button class="table-action-btn" type="button" title="Eliminar" @click="deleteSalepoint(sp.id)">
                        <i class="bi bi-trash"></i>
                      </button>
                    </div>
                  </td>
                </tr>
                <tr v-if="!isBusy && salePoints.length === 0">
                  <td colspan="6" class="data-table__empty">No hay puntos de venta cargados</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!-- FORMULARIO -->
      <div class="col-md-4">
        <NuevoSalePoint :salePointId="salePointId" :branchoffices="branchoffices" v-on:saved="refresh" />
      </div>
    </div>
  </div>
</template>

<script>

import NuevoSalePoint from './Nuevo-punto-de-venta.vue';

export default {
  components: {
    NuevoSalePoint,
  },
  data: function () {
    return {
      salePointId:null,
      salePoints:[],
      branchoffices:[],
      loading: false,
      isBusy:false,
      salePointfields: [
          {
            key: 'number',
            label: 'Numero',
            sortable: false
          },
          {
            key: 'branchoffice.name',
            label: 'Sucursal',
            sortable: true,
          },
          {
            key: 'type',
            label: 'Tipo',
            sortable: true
          },

          {
            key: 'editable',
            label: 'Tipo de numeración',
            sortable: true,
            formatter: value => {
              return value == 1 ? "Editable" : "Automática"
            }
          },
          {
            key: 'actived',
            label: 'Estado',
            sortable: true,
            formatter: value => {
              return value == 1 ? "Habilitado" : "Deshabilitado"
            }
          },
          {
            key: 'id',
            label: 'Acciones',
            sortable: false
          },
      ],
    };
  },
  mounted(){
    this.getSalePoints();
  },
  computed: {
  },
  methods: {
    canEdit(id) {
      return this.salePoints.filter(sp => sp.id == id )[0].type != 'ELEC';
    },
    refresh() {
      this.salePointId = null;
      this.getSalePoints();
    },
    getSalePoints() {
      var vm = this;
      vm.isLoading = true
      this.$http.get("/api/configs/getSalesPoints").then((response) => {
        vm.salePoints = response.data.data.salepoints;
        vm.branchoffices = response.data.data.branchoffices;
        vm.isLoading = false    
      });
    },
    edit(salePointId){
      this.salePointId = salePointId;
    },
    deleteSalepoint(salePointId) {
      if (confirm("Esta seguro que desea borrar este Punto de venta?") == true) {
        this.isLoading = true
        this.$http
          .post("/api/configs/pos/delete", { id: salePointId })
          .then((response) => {
            
            if (response.data.success) {
              this.refresh();
            }
          });
      }
    },
    afipUpdate(){
      var vm = this;
      vm.isLoading = true
      this.$http.post("/api/configs/pos/afip").then(() => {
        this.refresh();
      });
    }
  },
}
</script>